import type { FC, ReactNode } from "react";
import { Box } from '@hanzo/ui'

export interface TextBlockType {
  title: string;
  description: string;
  icon: string;
}

export const TextBlock: FC<TextBlockType> = (props) => {
  const { title, description, icon } = props;

  return (
    <Box className="max-w-[440px] z-2">
      <Box className="flex flex-row gap-3 justify-center">
        <img src={icon} alt={title} />
        <Box tag="p" className="text-white text-[24px] 2xl:text-[32px]">{title}</Box>
      </Box>
      <Box tag="p" className="mt-[45px] text-grey text-xl 2xl:text-2xl">{description}</Box>
    </Box>
  )
}